import React from 'react'
import SingleEditCategorySection from './SingleEditCategorySection'
import BatchEditCategorySection from './BatchEditCategorySection'
import type { CategorySectionProps } from '../../../../types'

const CategorySection: React.FC<CategorySectionProps> = (props) => {
  if (props.mode === 'edit') {
    return <SingleEditCategorySection {...props} />
  }
  
  return <BatchEditCategorySection {...props} />
}

export default CategorySection